module.exports = __webpack_public_path__ + "static/media/BR_Khaling_Resume.5e295934.pdf";